import React from 'react';
import { Field } from 'formik';

const TemperatureInput = ({ 
  name, 
  value, 
  disabled, 
  onBlur, 
  onChange,
  min = 20,
  max = 70
}) => {
  const isLoading = value === undefined || value === null;
  
  const containerStyle = {
    width: '70px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #eeeeee',
    borderRadius: '10px',
    padding: '2px 3px',
    height: '34px',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
    overflow: 'hidden'
  };
  
  // Loading animation
  const LoadingIndicator = () => (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      position: 'relative'
    }}>
      <div style={{
        width: '30px',
        textAlign: 'center',
        fontSize: '14px',
        color: '#bbbbbb',
        fontFamily: '"Poppins", sans-serif',
        position: 'relative'
      }}>
        {/* Animated dots */}
        <span style={{
          display: 'inline-block',
          animation: 'pulse 1.4s infinite ease-in-out',
          animationDelay: '0s'
        }}>.</span>
        <span style={{
          display: 'inline-block',
          animation: 'pulse 1.4s infinite ease-in-out',
          animationDelay: '0.2s'
        }}>.</span>
        <span style={{
          display: 'inline-block',
          animation: 'pulse 1.4s infinite ease-in-out',
          animationDelay: '0.4s'
        }}>.</span>
        
        <style>{`
          @keyframes pulse {
            0%, 100% {
              opacity: 0.2;
              transform: translateY(0);
            }
            50% {
              opacity: 1;
              transform: translateY(-2px);
            }
          }
        `}</style>
      </div>
      <span style={{
        position: 'absolute',
        top: '50%',
        right: '8px',
        transform: 'translateY(-50%)',
        fontSize: '12px',
        lineHeight: '14px',
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
        zIndex: 2,
        color: '#bbbbbb',
        fontFamily: 'Arial, sans-serif'
      }}>°C</span>
    </div>
  );

  return (
    <div className="temp-input-container" style={containerStyle}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: '#fff',
        zIndex: 0
      }}></div>
      
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <>
          <Field
            type="number"
            min={min}
            max={max}
            name={name}
            disabled={disabled}
            onBlur={onBlur}
            onChange={onChange}
            value={value || ''}
            style={{
              width: '40px',
              maxWidth: '40px',
              textAlign: 'center',
              paddingRight: '12px',
              paddingLeft: '0px',
              border: 'none',
              background: 'transparent',
              outline: 'none',
              margin: '0 auto',
              boxSizing: 'border-box',
              fontSize: '15px',
              color: '#7e7e7e',
              fontFamily: '"Poppins", sans-serif',
              position: 'relative',
              zIndex: 1,
              '-moz-appearance': 'textfield'
            }}
          />
          <span style={{
            position: 'absolute',
            top: '50%',
            right: '8px',
            transform: 'translateY(-50%)',
            fontSize: '12px',
            lineHeight: '14px',
            pointerEvents: 'none',
            whiteSpace: 'nowrap',
            zIndex: 2,
            color: '#7e7e7e',
            fontFamily: 'Arial, sans-serif'
          }}>°C</span>
        </>
      )}
    </div>
  );
};

export default TemperatureInput; 